// import { ErrorBoundary } from 'react-error-boundary'
// import { Fallback } from '@/shared/ui'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { TooltipProvider } from '@/shared/ui/tooltip';
import { ReactNode } from 'react';

interface IProviders {
  readonly children: ReactNode;
  readonly queryClient: QueryClient; // Принимаем queryClient через пропсы
}

export const Providers = ({ children, queryClient }: IProviders) => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      {/* <ErrorBoundary FallbackComponent={Fallback}> */}
      <TooltipProvider>{children}</TooltipProvider>
      {/* </ErrorBoundary> */}
    </QueryClientProvider>
  );
};
